module.exports = __webpack_public_path__ + "static/media/starshipit3_preview.b4565e3a.jpg";